import styled from "styled-components";

// Styled Components
export const PlayerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  /* padding: 1.5rem; */
  /* background: ${({ theme }) => theme.gradients.card}; */
  backdrop-filter: blur(10px);
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  border: 1px solid ${({ theme }) => theme.colors.borderPrimary};
  box-shadow: 0 0 20px rgba(139, 92, 246, 0.1);
`;

export const ControlsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  flex-wrap: wrap;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    gap: 1rem;
    flex-wrap: nowrap;
  }
  background: ${({ theme }) =>
    `linear-gradient(to right, ${theme.colors.backgroundDark}, transparent)`};
  border-radius: ${({ theme }) => theme.borderRadius.md};
`;

export const PlayButton = styled.button<{
  $isPlaying: boolean;
  $isLoading?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  cursor: ${(props) => (props.$isLoading ? "wait" : "pointer")};

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 3rem;
    height: 3rem;
  }
  border-radius: 50%;
  border: ${({ $isPlaying, theme }) =>
    $isPlaying ? `none` : `2px solid ${theme.colors.borderPrimary}`};
  background: ${({ $isPlaying, theme }) =>
    $isPlaying ? theme.gradients.button : "transparent"};
  color: ${({ $isPlaying, theme }) =>
    $isPlaying ? theme.colors.text : theme.colors.primary};
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.gradients.glow};
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: scale(1.05);
    border-color: ${({ theme }) => theme.colors.primary};

    &::before {
      opacity: 1;
    }
  }

  &:active {
    transform: scale(0.95);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }
`;

export const TimeDisplay = styled.div`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textMuted};
  width: 2.8rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 3.5rem;
  }
  text-align: center;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.5px;
`;

export const SliderContainer = styled.div`
  position: relative;
  flex: 1;
  height: 0.5rem;
  display: flex;
  align-items: center;
  /* padding: 0 0.5rem; */
`;

export const SliderHighlight = styled.div<{
  $percentStart: number;
  $percentEnd: number;
  $percentCurrent: number;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  background: ${({ $percentStart, $percentEnd, theme }) => `
    linear-gradient(
      to right,
      ${theme.colors.sliderBackground} 0%,
      ${theme.colors.sliderBackground} ${$percentStart}%,
      ${theme.colors.primary} ${$percentStart}%,
      ${theme.colors.primary} ${$percentEnd}%,
      ${theme.colors.sliderBackground} ${$percentEnd}%,
      ${theme.colors.sliderBackground} 100%
    )
  `};
  border-radius: 9999px;
`;

export const Slider = styled.input`
  position: relative;
  width: 100%;
  margin: 0;
  height: 3px;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
  z-index: 2;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 19px;
    height: 19px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 10px ${({ theme }) => theme.colors.primary}40;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: -2px;

    &:hover {
      transform: scale(1.2);
      box-shadow: 0 0 20px ${({ theme }) => theme.colors.primary}80;
    }

    &:active {
      transform: scale(0.9);
    }
  }

  &::-moz-range-thumb {
    width: 19px;
    height: 19px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.primary};
    border: 2px solid ${({ theme }) => theme.colors.background};
    box-shadow: 0 0 10px ${({ theme }) => theme.colors.primary}40;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: -2px;

    &:hover {
      transform: scale(1.2);
      box-shadow: 0 0 20px ${({ theme }) => theme.colors.primary}80;
    }

    &:active {
      transform: scale(0.9);
    }
  }

  &::-webkit-slider-runnable-track,
  &::-moz-range-track {
    height: 3px;
    background: transparent;
  }

  &:hover::-webkit-slider-runnable-track,
  &:hover::-moz-range-track {
    height: 5px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &::-webkit-slider-thumb,
    &::-moz-range-thumb {
      transform: none;
      box-shadow: none;
    }
  }
`;

export const VolumeContainer = styled.div`
  display: none;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: flex;
  }
  background: ${({ theme }) => theme.colors.backgroundDark};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  border: 1px solid ${({ theme }) => theme.colors.borderPrimary};
`;

export const VolumeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.text};
  cursor: pointer;
  padding: 0.25rem;
  transition: all 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }
`;

export const VolumeSlider = styled.input`
  width: 4rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 5rem;
  }
  height: 3px;
  -webkit-appearance: none;
  appearance: none;
  background: ${({ theme }) => theme.colors.sliderBackgroundDark};
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    height: 4px;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.primary};
    border: 2px solid ${({ theme }) => theme.colors.background};
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 0px;

    &:hover {
      transform: scale(1.2);
      box-shadow: 0 0 15px ${({ theme }) => theme.colors.primary}60;
    }

    &:active {
      transform: scale(0.9);
    }
  }

  &::-moz-range-thumb {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.primary};
    border: 2px solid ${({ theme }) => theme.colors.background};
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: -3.5px;

    &:hover {
      transform: scale(1.2);
      box-shadow: 0 0 15px ${({ theme }) => theme.colors.primary}60;
    }

    &:active {
      transform: scale(0.9);
    }
  }

  &::-webkit-slider-runnable-track,
  &::-moz-range-track {
    height: 3px;
    background: transparent;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.875rem;
  padding: 0.5rem;
  background: ${({ theme }) => theme.colors.backgroundDark};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  border: 1px solid ${({ theme }) => theme.colors.borderPrimary};
`;

export const CustomPlaybackIndicator = styled.span`
  color: ${({ theme }) => theme.colors.accent};
  background: ${({ theme }) =>
    `linear-gradient(to right, ${theme.colors.accent}20, transparent)`};
  padding: 0.25rem 0.75rem;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  border: 1px solid ${({ theme }) => theme.colors.accent}40;
  font-weight: 500;
  animation: pulse 2s infinite;

  @keyframes pulse {
    0% {
      opacity: 0.7;
      transform: scale(0.98);
    }
    50% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0.7;
      transform: scale(0.98);
    }
  }
`;
export const LoaderSpinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
